<template>
    <div v-if="showHoldBooking" class="d-flex flex-column flex-md-row align-md-center">
        <v-checkbox v-model="dueToConfirmDateActive" hide-details class="me-2">
            <template v-slot:label>
                <div class="confirmation-text" @click.stop>
                    {{ $t('need_hold_booking') }}
                </div>
            </template>
        </v-checkbox>
        <!-- TODO [P0] Need check -->
        <!-- eslint-disable vue/no-custom-modifiers-on-v-model -->
        <vc-date-picker
            v-model.string="dueToConfirmDate"
            :masks="masks"
            :locale="$i18n.locale"
            :min-date="minDateTime"
            :max-date="initialDueToConfirmDate"
            :first-day-of-week="$conf.public.firstDayOfWeek || undefined"
            mode="dateTime"
            is24hr
            is-required
        >
            <template v-slot="{inputEvents}">
                <div v-on="dueToConfirmDateActive && isTO1 ? inputEvents : null">
                    <v-text-field
                        :label="$t('prebooking_until')"
                        readonly
                        single-line
                        style="min-width: 250px"
                        hide-details
                        bg-color="white"
                        prepend-inner-icon="mdi-av-timer"
                        :model-value="formattedDate"
                        density="compact"
                        :disabled="!(dueToConfirmDateActive && isTO1)"
                        class="date-input"
                    />
                </div>
            </template>
        </vc-date-picker>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class DueToConfirmDateCheckbox extends Vue {
        @Prop({required: true}) startDate
        @Prop() _dueToConfirmDate
        @Prop() _dueToConfirmDateActive

        initialDueToConfirmDate = null

        @Emit()
        changeDueToConfirmDate(val) {
            return val
        }

        @Emit()
        changeDueToConfirmDateActive(val) {
            return val
        }

        mounted() {
            this.initialDueToConfirmDate = this._dueToConfirmDate
        }

        get minDateTime() {
            return this.$dateFns.format(new Date())
        }

        get isTO1() {
            return authStore.isTO1
        }

        get formattedDate() {
            return this._dueToConfirmDate !== null ? this.$filters.dateTimeFormat(this._dueToConfirmDate) : ''
        }

        get showHoldBooking() {
            return (
                this._dueToConfirmDate &&
                this.$dateFns.isAfter(
                    this.$dateFns.parseISO(this._dueToConfirmDate),
                    this.$dateFns.subDays(new Date(), 1)
                ) &&
                this.$dateFns.isBefore(
                    this.$dateFns.parseISO(this._dueToConfirmDate),
                    this.$dateFns.addDays(this.$dateFns.parseISO(this.startDate), 1)
                ) &&
                this.isTO1
            )
        }

        get dueToConfirmDate() {
            return this._dueToConfirmDate
        }

        set dueToConfirmDate(val) {
            this.changeDueToConfirmDate(val)
        }

        get dueToConfirmDateActive() {
            return this._dueToConfirmDateActive
        }

        set dueToConfirmDateActive(val) {
            this.changeDueToConfirmDateActive(val)
        }

        get masks() {
            return {modelValue: 'YYYY-MM-DD HH:mm'}
        }
    }

    export default DueToConfirmDateCheckbox
</script>

<style scoped lang="scss">
    .confirmation-text {
        font-size: 0.875rem;
    }

    .date-input {
        min-width: 210px;
    }
</style>
